import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Form, Input, Pagination, Row, Table } from "antd";
import moment from "moment";

import promotionApi from "../../../apis/Promotion.api";
import { setLoading } from "../../../redux/store/common/commonDuck";

const CouponListComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [form] = Form.useForm();

  const [searchOptions, setSearchOptions] = useState({
    coupon_id: "",
    coupon_title: "",
  });
  const [orderType, setOrderType] = useState("updated_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [totalSize, setTotalSize] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [couponList, setCouponList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [selectedRows, setSelectedRows] = useState([]);
  const [btnStatus, setBtnStatus] = useState(0); // 0: disabled, 1: 다운로드 불가능, 2: 다운로드 가능
  const [availableBtnStatus, setAvailableBtnStatus] = useState(0); // 0: disabled, 1: 사용 불가능, 2: 사용 가능
  // const [error, setError] = useState("");

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRows?.length > 0) {
        const possibleResult = selectedRows.every(
          (row) => row.coupon_publish_available,
        );
        const availableResult = selectedRows.every(
          (row) => row.coupon_is_available,
        );
        if (possibleResult) {
          setBtnStatus(1);
        } else {
          const impossibleResult = selectedRows.every(
            (row) => !row.coupon_publish_available,
          );
          if (impossibleResult) {
            setBtnStatus(2);
          } else {
            setBtnStatus(0);
          }
        }
        if (availableResult) {
          setAvailableBtnStatus(1);
        } else {
          const unavailableResult = selectedRows.every(
            (row) => !row.coupon_is_available,
          );
          if (unavailableResult) {
            setAvailableBtnStatus(2);
          } else {
            setBtnStatus(0);
          }
        }
      }
      setSelectedRowKeys(selectedRowKeys);
      // setSelectedRows(selectedRows);
    },
  };

  const columns = [
    {
      title: "쿠폰번호",
      width: 150,
      dataIndex: "coupon_id",
      key: "coupon_id",
      fixed: "left",
      ellipsis: true,
    },
    {
      title: "쿠폰 종류",
      width: 120,
      dataIndex: "coupon_type",
      key: "coupon_type",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value === "category") {
          return <span>카테고리</span>;
        } else if (value === "brand") {
          return <span>브랜드</span>;
        } else if (value === "product") {
          return <span>상품</span>;
        } else if (value === "related_product") {
          return <span>연관상품</span>;
        } else if (value === "event") {
          return <span>이벤트</span>;
        } else if (value === "event_all") {
          return <span>전체 상품 대상 이벤트</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "쿠폰명",
      width: 120,
      dataIndex: "coupon_title",
      key: "coupon_title",
      ellipsis: true,
    },
    {
      title: "할인",
      width: 50,
      dataIndex: "coupon_score",
      key: "coupon_score",
      ellipsis: true,
      render: (value, record) => {
        if (record.coupon_score_type === 1) {
          return <span>{value}원</span>;
        } else {
          return <span>{value}%</span>;
        }
      },
    },
    {
      title: "사용기간",
      width: 280,
      // dataIndex: 'coupon_duration',
      // key: 'coupon_duration',
      ellipsis: true,
      render: (value, recode) => {
        if (recode.coupon_from !== null) {
          const startDate = moment(recode.coupon_from).format(
            "YYYY-MM-DD HH:mm",
          );
          if (recode.coupon_to !== null) {
            const endDate = moment(recode.coupon_to).format("YYYY-MM-DD HH:mm");
            return (
              <span>
                {startDate} ~ {endDate}
              </span>
            );
          } else {
            return <span>{startDate} ~ </span>;
          }
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "발급수",
      width: 90,
      dataIndex: "coupon_usage_number",
      key: "coupon_usage_number",
      ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: "다운로드 가능 여부",
      width: 110,
      dataIndex: "coupon_publish_available",
      key: "coupon_publish_available",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return <span>다운로드 가능</span>;
        } else {
          return <span>다운로드 불가능</span>;
        }
      },
    },
    {
      title: "사용 가능 여부",
      width: 110,
      dataIndex: "coupon_is_available",
      key: "coupon_is_available",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return <span>사용 가능</span>;
        } else {
          return <span>사용 불가능</span>;
        }
      },
    },
    {
      title: "최종수정일",
      width: 140,
      dataIndex: "updated_at",
      key: "updated_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return <span>{date}</span>;
        }
      },
    },
    // {
    //   title: '수정자',
    //   width: 90,
    //   dataIndex: 'updated_by_name',
    //   key: 'updated_by_name',
    //   ellipsis: true
    // },
    {
      title: "생성일",
      width: 140,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return <span>{date}</span>;
        }
      },
    },
    // {
    //   title: '생성자',
    //   width: 90,
    //   dataIndex: 'created_by_name',
    //   key: 'created_by_name',
    //   ellipsis: true
    // },
  ];

  useEffect(() => {
    getReadCouponList();
  }, []);

  useEffect(() => {
    getReadCouponList();
  }, [offset, pageSize, orderType, orderBy]);

  useEffect(() => {
    if (selectedRowKeys?.length === 0) {
      setBtnStatus(0);
      setAvailableBtnStatus(0);
    }
  }, [selectedRowKeys]);

  const getReadCouponList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await promotionApi.readCouponList(
          0,
          10,
          searchOptions.coupon_id,
          searchOptions.coupon_title,
          orderType,
          orderBy,
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await promotionApi.readCouponList(
          offset,
          pageSize,
          searchOptions.coupon_id,
          searchOptions.coupon_title,
          orderType,
          orderBy,
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setCouponList(res.result.couponList);
        setTotalSize(res.result.totalCnt);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("couponList read error", error);
    }
  };

  /**
   * Form value change handle
   * @param changedValues : 변경 이벤트가 발생하는 값
   * @param allValues : Form의 모든 값
   */
  const handleFormValuesChange = (changedValues, allValues) => {
    setSearchOptions({ ...searchOptions, ...changedValues });
  };

  /**
   * 다운로드 가능 여부 수정 버튼 click
   */
  const handleEditBtnClick = async () => {
    setIsLoading(true);
    try {
      let newEditCoupon = {
        editList: selectedRowKeys,
        editKey: "coupon_publish_available",
        created_by: user.id === 724 ? 1 : user.id,
        // editor: user.user_id
      };
      if (btnStatus === 2) {
        newEditCoupon["editValue"] = true;
      } else if (btnStatus === 1) {
        newEditCoupon["editValue"] = false;
      }
      const res = await promotionApi.editCoupon(newEditCoupon);
      if (res.code === 200) {
        alert("해당 내용이 성공적으로 수정되었습니다.");
        getReadCouponList();
        setSelectedRowKeys([]);
        // setSelectedRows([]);
      } else if (res.code === 999) {
        alert(res.msg);
      } else {
        alert(
          "선택한 쿠폰들의 다운로드 가능 여부 상태값 수정에 실패하였습니다. 다시 시도하시거나 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("handleEditBtnClick edit error", error);
    }
  };

  /**
   * 사용 가능 여부 수정 버튼 click
   */
  const handleEditAvailableBtnClick = async () => {
    setIsLoading(true);
    try {
      let newEditCoupon = {
        editList: selectedRowKeys,
        editKey: "coupon_is_available",
        created_by: user.id === 724 ? 1 : user.id,
        // editor: user.user_id
      };
      if (availableBtnStatus === 2) {
        newEditCoupon["editValue"] = true;
      } else if (availableBtnStatus === 1) {
        newEditCoupon["editValue"] = false;
      }
      const res = await promotionApi.editCoupon(newEditCoupon);
      if (res.code === 200) {
        alert("해당 내용이 성공적으로 수정되었습니다.");
        getReadCouponList();
        setSelectedRowKeys([]);
        // setSelectedRows([]);
      } else if (res.code === 999) {
        alert(res.msg);
      } else {
        alert(
          "선택한 쿠폰들의 사용 가능 여부 상태값 수정에 실패하였습니다. 다시 시도하시거나 관리자에게 문의하시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("handleEditAvailableBtnClick edit error", error);
    }
  };

  const handleSearch = () => {
    setOffset(0);
    setPageSize(10);
    getReadCouponList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
      } else {
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
        setOrderType("updated_at");
        setOrderBy("desc");
      }
    }
  };

  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        history.push(`/promotion/coupon/register/${record.id}`);
      },
    };
  };

  /**
   * page 넘김
   * @param pageNumber
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  /**
   * pageSize 변경 handler
   * @param current
   * @param pageSize
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset(0);
    setCurrentPageNumber(1);
  };

  return (
    <div className="contentPage" style={{ margin: 24 }}>
      <Form
        form={form}
        onValuesChange={handleFormValuesChange}
        onFinish={handleSearch}
        labelCol={{ span: 2 }}
        wrapperCol={{ span: 10 }}
      >
        <Form.Item
          label="쿠폰번호"
          name="coupon_id"
          colon={false}
          labelAlign={"left"}
        >
          <Input placeholder="" onPressEnter={handleSearch} />
        </Form.Item>
        <Form.Item
          label="쿠폰명"
          name="coupon_title"
          colon={false}
          labelAlign={"left"}
        >
          <Input placeholder="" onPressEnter={handleSearch} />
        </Form.Item>
        <Form.Item className="coupon-search-btn-wrap" wrapperCol={{ span: 24 }}>
          <Button
            type="primary"
            className="coupon-search-btn"
            onClick={handleSearch}
          >
            검색
          </Button>
        </Form.Item>
      </Form>

      <div className="coupon-table-header-buttons-wrap">
        <Row>
          <Button
            className="coupon-table-header-btn"
            type="primary"
            disabled={btnStatus === 0}
            danger={btnStatus === 1}
            onClick={handleEditBtnClick}
          >
            {btnStatus === 2 ? "다운로드 가능" : "다운로드 불가능"}
          </Button>
          <Button
            className="coupon-table-header-btn"
            type="primary"
            disabled={availableBtnStatus === 0}
            danger={availableBtnStatus === 1}
            onClick={handleEditAvailableBtnClick}
            style={{ marginLeft: 10 }}
          >
            {availableBtnStatus === 2 ? "사용 가능" : "사용 불가능"}
          </Button>
        </Row>
        <div style={{ paddingTop: "5px" }}>
          Total : {totalSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </div>
      </div>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={couponList}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="id"
        rowClassName="coupon-table-row"
        scroll={{ x: "max-content" }}
        tableLayout={"auto"}
        onRow={handleRowEvent}
        onChange={tableOnChange}
        pagination={false}
      />

      <div style={{ textAlign: "right" }}>
        <Pagination
          showQuickJumper
          showSizeChanger
          onShowSizeChange={pageSizeChange}
          total={totalSize}
          onChange={handleChangePagination}
          style={{ marginTop: 20 }}
          current={currentPageNumber}
        />
      </div>
    </div>
  );
};

export default CouponListComponent;
